module.exports = __webpack_public_path__ + "img/status-icn_refund_pending@3x.08d840e9.png";